import React from "react";
import { Table } from "antd";
import "./Table.css";
import CustomPagination from "./CustomPagination";

const CommonTable = ({
  data,
  columns,
  tableTitle,
  rowClickable,
  settingModalDataFunction,
  showLoader,
  pagination,
  onChange,
}) => {
  return (
    <>
      <div className="common-table-card">
        <div className="common-table-body">
          {showLoader ? (
            <div className="table-loader-wrapper">
              {/* <Loader /> */}
              <h3>Loading...</h3>
            </div>
          ) : (
            <div className="custom-table-wrapper table-responsive custom-scrollbar">
              <Table
                className="custom-ant-table"
                dataSource={data?.content || data}
                columns={columns}
                 rowKey={(record) => record.userId || record.id || record.key} 
                pagination={false}
                onRow={(record) => ({
                  onClick: () =>
                    rowClickable ? settingModalDataFunction(record) : null,
                })}
                rowClassName={() => (rowClickable ? "pointer-cursor" : "")}
                onChange={onChange}
              />
            </div>
          )}
        </div>

        {pagination && pagination.total > pagination.pageSize && (
          <CustomPagination
            pagination={pagination}
            onPageChange={(page, size) =>
              onChange({ current: page, pageSize: size })
            }
          />
        )}
      </div>
    </>
  );
};

export default CommonTable;